import { useContext } from 'react';
import { useOpenSoftPullModal } from '@/Modals/SoftPullMfeModal/useToggleSoftPullModal';
import ResultTile from '@/SearchResults/ResultTile/ResultTile';
import FavoritesContext from '~/contexts/FavoritesContext';
import type { Vehicle } from '~/contracts';

type OwnProps = {
  vehicles: Vehicle[];
};

export default function SimilarResults({ vehicles }: OwnProps) {
  const { favorites } = useContext(FavoritesContext);
  const openSoftPullModal = useOpenSoftPullModal();

  const favoriteVehicleIds = favorites.map(v => v.vehicleId);

  return (
    <>
      {vehicles.map(v => {
        const vehicle: Vehicle = {
          ...v,
          isFavorite: favoriteVehicleIds.includes(v.vehicleId)
        };

        return (
          <ResultTile
            key={v.vehicleId}
            openSoftPullModal={openSoftPullModal}
            vehicle={vehicle}
          />
        );
      })}
    </>
  );
}
